import { useState } from 'react';

import Preview from 'pages/SampleVideo/CreateSampleVideo/_components/Preview';
import Video from 'pages/Users/Detail/VideoResult/_components/Video';

const VideoList = ({ listVideo }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleMappingVideos = () => {
    let result = [];
    for (const videos of listVideo) {
      for (const item of videos.video_response_snapshot.videos) {
        if (item.video_url || (item.source_bucket && item.source_blob)) {
          result.push({
            type: 'video',
            url: item.video_url,
            source_bucket: item.source_bucket,
            source_blob: item.source_blob,
            categoryName: item.video_category.name,
          });
        }
      }
    }
    return result.filter((item) => item.url || (item.source_bucket && item.source_blob));
  };

  return (
    <>
      <div className="w-full h-full px-3 py-4 bg-white">
        <div className="px-3">
          <p className="font-bold text-[22px] h-[33px]">動画一覧</p>
        </div>
        <div className="mt-6 overflow-y-auto h-[calc(100%-33px-24px)] px-3">
          <div className="grid grid-cols-12">
            {handleMappingVideos()?.map(
              (item, index) =>
                (item.url || (item.source_bucket && item.source_blob)) && (
                  <div
                    key={index}
                    className="col-span-4 border border-solid border-gray-651"
                    onClick={() => {
                      setShowPreview(true);
                      setCurrentIndex(index);
                    }}
                  >
                    <Video videoUrl={item.url} sourceBucket={item.source_bucket} sourceBlob={item.source_blob} categoryName={item.categoryName} />
                  </div>
                )
            )}
          </div>
        </div>
      </div>

      {showPreview && <Preview media_files={handleMappingVideos()} close={() => setShowPreview(false)} firstOpen={currentIndex} />}
    </>
  );
};

export default VideoList;
